import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8e105256"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cm-message-header" }
const _hoisted_2 = { class: "cm-message-body" }
const _hoisted_3 = ["innerHTML"]

import { computed, onMounted, PropType, ref } from 'vue'
import { i18n } from '@/i18n'
import { router } from '@/router'
import { Content } from '@/views/_components/message-template/custom-message/custom-message.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'custom-message',
  props: {
  header: {
    type: String,
    default: ''
  },
  content: {
    type: Object as PropType<Content>,
    default: () => ({} as any)
  },
  notificationKey: {
    type: String,
  }
},
  emits: ['closeDetails'],
  setup(__props, { emit: __emit }) {

const emits = __emit

const props = __props

const t = i18n.global.t.bind(i18n.global)

const displayHeader = computed(() =>
  props.header || t('messageTemplate.customDefaultHeader')
)

const rootRef = ref(null)

function initLinkElement () {
  rootRef.value.querySelectorAll('[cm_custom_message_link]').forEach((element) => {
    element.classList.add('cm-link-light')
    element.classList.add('underline')
    element.addEventListener('click', () => {
      emits('closeDetails')
      router.push(element.getAttribute('cm_custom_message_link'))
    })
  })
}

/** 调试消息内容工具 */
function testHtml () {
  // 修改模板字符串以调试消息内容
  props.content.html = `为精准提升服务质量、优化您的使用体验，诚邀您参与一份 <a href="https://www.baidu.com/" target="_blank">简短问卷</a> ！仅需 3 分钟即可完成，您的每一条意见都对我们至关重要，助力服务迭代升级，感谢支持～`

  const contentData = { html: props.content.html }
  const contentDataStringify = JSON.stringify(contentData)
  // 输出可直接复制提供给后端的转义后content字段
  console.log('直接复制提供给后端的数据 ==>', JSON.stringify({ content: contentDataStringify }).slice(1, -1))
}

/** 调试消息内容 */
// testHtml()

onMounted(() => {
  initLinkElement()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "cm-message-template",
    ref_key: "rootRef",
    ref: rootRef
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(displayHeader.value), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        innerHTML: __props.content.html
      }, null, 8, _hoisted_3)
    ])
  ], 512))
}
}

})